module.exports = __webpack_public_path__ + "static/img/grande_about_en.d7e23ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_bole/grande_about_en.jpg
// module id = wb9V
// module chunks = 1